<template>
  <v-autocomplete
    outlined
    filled
    hide-details
    hide-no-data
    append-icon=""
    :clearable="clearable"
    :items="data"
    :multiple="multiple"
    :item-text="itemText"
    class="bs-search-item"
    :placeholder="placeholder"
    :disabled="disabled"
    background-color="#ffffff"
    v-model="selectedValue"
    return-object
  >
    <template v-slot:prepend-inner>
      <slot name="prependIcon"/>
    </template>
    <template v-slot:append>
      <slot name="appendIcon"/>
    </template>
    <template v-slot:append-item>
      <div v-if="!disableLoader" class="intersection-wrapper d-flex justify-center">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
      <div v-intersect.quiet="endIntersect" />
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  name: 'infinite-scroll',
  props: {
    selectedName: {
      type: String,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    itemText: {
      type: String,
      default: 'name',
    },
    data: {
      type: Array,
      required: true,
    },
    listSearchParams: {
      type: Object,
      required: true,
    },
    totalCount: {
      type: Number,
      required: true,
    },
    placeholder: {
      type: String,
    },
    disabled: {
      type: Boolean,
    },
  },
  data() {
    return {
      selectedValue: null,
    };
  },
  methods: {
    endIntersect(intersectionObj) {
      if (this.disableLoader) return;

      if (intersectionObj[0].isIntersecting) {
        this.$emit('intersect');
      }
    },
  },
  watch: {
    selectedName: {
      handler(val) {
        if (val) {
          this.selectedValue = this.data.find((el) => el.id === val);
          return;
        }

        this.selectedValue = null;
      },
      immediate: true,
    },
    selectedValue(val) {
      this.$emit('selectItem', val);
    },
  },
  computed: {
    disableLoader() {
      if (this.data.length === this.totalCount) return true;

      return false;
    },
  },
  beforeDestroy() {
    this.intersection = false;
  },
};
</script>

<style lang="scss">
.bs-search-item {
  & .v-select__slot {
    & input {
      padding-bottom: 0px !important;
    }
  }
}
</style>

<style lang="scss" scoped>
.intersection-wrapper {
  width: 100%;
}
</style>
